/** 接口路径（sidecar 的路由：routers/devices.py、dashboard_devices.py、test_devices.py、access_api.py，main.py 的 /api/console/me）。 */

const sn = (s: string) => encodeURIComponent(s);

export const API = {
  me: '/api/console/me',
  devices: '/api/dashboard/devices',
  deviceStatus: (s: string) => `/api/devices/${sn(s)}/status`,
  deviceUsageInfo: (s: string) => `/api/devices/${sn(s)}/usage-info`,
  deviceHistory: (s: string) => `/api/dashboard/devices/${sn(s)}/history`,
  deviceFaces: (s: string) => `/api/dashboard/devices/${sn(s)}/faces`,
  deviceVoiceprints: (s: string) => `/api/dashboard/devices/${sn(s)}/voiceprints`,
  deviceMemory: (s: string) => `/api/dashboard/devices/${sn(s)}/memory`,
  deviceDiaries: (s: string) => `/api/dashboard/devices/${sn(s)}/diaries`,
  filteredInputs: (s: string) => `/api/dashboard/devices/${sn(s)}/filtered-inputs`,
  conversationHistory: (s: string) => `/api/dashboard/devices/${sn(s)}/conversation-history`,
  /** 「对话」页签上的轮数：只是个数，不是内容（取对话记录会被记一笔「看了对话」） */
  conversationCount: (s: string) => `/api/dashboard/devices/${sn(s)}/conversation-count`,
  conversationSearch: (s: string) => `/api/dashboard/devices/${sn(s)}/conversations`,
  conversationPage: (s: string) => `/api/dashboard/devices/${sn(s)}/conversation-page`,
  conversationContext: (s: string) => `/api/dashboard/devices/${sn(s)}/conversation-context`,
  /** 设备录音是 MinIO / OSS 里的 PCM，经它转成 wav 才能放（给 <audio> 用，不走 apiGet）。
   *  录音是设备内容：带上这台设备的 SN，sidecar 按它过查看理由的门、记一笔 */
  audioProxy: (s: string, url: string, sampleRate?: number) => `/api/dashboard/audio-proxy?${new URLSearchParams({ sn: s, url, ...(sampleRate === undefined ? {} : { sampleRate: String(sampleRate) }) }).toString()}`,
  testDevices: '/api/dashboard/test-devices',
  testConversations: (s: string) => `/api/dashboard/test-devices/${sn(s)}/conversations`,
  accessGrants: '/api/access/grants',
  accessLog: '/api/access/log',
} as const;
